import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CalendlyFab from '../../components/CalendlyFab';

const Automation = () => {
  return (
    <div className="bg-dark min-vh-100">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3 text-light">Automation Solutions</h1>
          <p className="lead text-warning fw-bold">Streamline Your Operations with Smart Automation</p>
          <Link to="/klassitech">
            <Button variant="outline-warning" className="mt-3">
              <i className="bi bi-arrow-left me-2"></i>
              Back to KlassiTech
            </Button>
          </Link>
        </div>

        <Row className="g-4 mb-5">
          <Col xs={12} sm={6} md={4} className="text-center">
            <Link to="/klassitech/automation" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/test-automation.jpeg"
                  alt="Test Automation"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Test Automation</h3>
              <p className="text-light-50">
                Automated testing solutions for quality assurance.
                Improve efficiency and reduce manual testing time.
              </p>
            </Link>
          </Col>
          <Col xs={12} sm={6} md={4} className="text-center">
            <Link to="/klassitech/automation" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/process-automation.jpeg"
                  alt="Process Automation"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Process Automation</h3>
              <p className="text-light-50">
                Streamline business processes with automation.
                Reduce errors and increase productivity.
              </p>
            </Link>
          </Col>
          <Col xs={12} sm={6} md={4} className="text-center">
            <Link to="/klassitech/automation" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/ci-cd-automation.jpeg"
                  alt="CI/CD Automation"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">CI/CD Automation</h3>
              <p className="text-light-50">
                Automated deployment and integration pipelines.
                Faster and more reliable software delivery.
              </p>
            </Link>
          </Col>
        </Row>

        <Row className="g-4">
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Our Automation Process</h2>
              <ul className="text-primary">
                <li className="mb-2">Comprehensive process analysis</li>
                <li className="mb-2">Custom automation strategy</li>
                <li className="mb-2">Implementation and integration</li>
                <li className="mb-2">Testing and quality assurance</li>
                <li className="mb-2">Ongoing support and optimization</li>
              </ul>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Automation Benefits</h2>
              <p className="text-primary mb-4">
                Experience the advantages of our automation solutions:
              </p>
              <ul className="text-primary">
                <li className="mb-2">Increased efficiency and productivity</li>
                <li className="mb-2">Reduced operational costs</li>
                <li className="mb-2">Improved accuracy and consistency</li>
                <li className="mb-2">Faster time to market</li>
                <li className="mb-2">Scalable and maintainable solutions</li>
              </ul>
            </div>
          </Col>
        </Row>

        <div className="mt-5">
          <div className="bg-dark p-4 rounded shadow mb-4">
            <h3 className="text-light text-center mb-3">Automation in Action</h3>
            <div className="text-center">
              <img 
                src="/images/automation-diagram.png" 
                alt="Automation Solution Diagram"
                className="img-fluid rounded"
                style={{ 
                  maxWidth: '80%',
                  width: '600px',
                  height: 'auto',
                  border: '3px solid #FFD700',
                  borderRadius: '15px',
                  margin: '0 auto'
                }}
              />
              <p className="text-primary mt-2 mb-0">
                Our automation solution brings together testing, process automation, and CI/CD pipelines into a single, streamlined workflow. By automating repetitive tasks and integrating continuous delivery, we help your team move faster, reduce errors, and focus on building great software — from development to deployment.
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mt-4">
          <Link to="/klassitech" className="btn btn-outline-warning">
            <i className="bi bi-arrow-left me-2"></i>
            Back to KlassiTech
          </Link>
        </div>

        <CalendlyFab />
      </Container>
    </div>
  );
};

export default Automation; 